import { labelServiceImage } from '../../helpers/services/productLabelImage.service';
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'
// import { SESSION } from "@/constants";
// import router from '@/router/index';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
}

export const PRODUCT_LABEL_IMAGE_MODULE = 'productLabelImage';

// ACTIONS
export const UPDATE_PRODUCT_LABEL_IMAGE_STATUS = 'updateProductLabelImageStatus';
export const UPDATE_PRODUCT_LABEL_STATUS_IMAGE_NEW = 'updateProductLabelStatusImageNew';

// MUTATIONS
const REQUESTING = "requesting";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";

export const actions = {
    [UPDATE_PRODUCT_LABEL_IMAGE_STATUS]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return labelServiceImage
            .updateLabelImageStatusNew(data)
            .then((result) => {
                var message = i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [i18n.t('label.image')]);
                sharedHelper.alertSuccessMessage(message);
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                commit(FAILURE);
            });
    },
    [UPDATE_PRODUCT_LABEL_STATUS_IMAGE_NEW]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return labelServiceImage
            .updateLabelImageStatusImageNew(data)
            .then((result) => {
                var message = i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [i18n.t('label.image')]);
                sharedHelper.alertSuccessMessage(message);
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                sharedHelper.alertErrorMessage(message, error?.response?.data?.code);
                commit(FAILURE);
            });
    },
};

export const mutations = {
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};